// This file is automatically updated by the build process.
export const VERSION = '__PACKAGE_VERSION__';
